import React from 'react';
import { Chip, List, ListItem, Paper, Stack, Typography } from '@mui/material';

// Already ranked by getLeaderboard; resorting here would break tie stability.
function Leaderboard({ entries = [], sx }) {
    return (
        <Paper variant="outlined" sx={{ maxWidth: 480, mx: 'auto', p: 2, ...sx }}>
            <List disablePadding data-testid="leaderboard">
                {entries.map((entry, index) => (
                    <ListItem
                        key={entry.displayName}
                        sx={{
                            border: '2px solid',
                            borderColor: 'divider',
                            borderRadius: 2,
                            py: 1.25,
                            px: 2,
                            mb: index === entries.length - 1 ? 0 : 1.5,
                        }}
                    >
                        <Stack direction="row" spacing={1.5} alignItems="center" sx={{ width: '100%' }}>
                            <Typography sx={{ width: '2ch', fontWeight: 700, color: 'text.secondary' }}>
                                {index + 1}
                            </Typography>
                            <Typography sx={{ flexGrow: 1, textAlign: 'left', fontWeight: 600 }}>
                                {entry.displayName}
                            </Typography>
                            <Chip label={entry.score} color="primary" size="small" />
                        </Stack>
                    </ListItem>
                ))}
            </List>
        </Paper>
    );
}

export default Leaderboard;
